// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contextMenu_wrapper__81GsE","trigger":"contextMenu_trigger__CGAf4","menu":"contextMenu_menu__l5NR6","overlay":"contextMenu_overlay__harQj"};